// WARNING: This file is auto-generated. Do not edit directly.
import { baseTokens } from './base';
import type { SemanticTokens } from './types';

export const semanticTokensMerchant = {
  content: {
    default: {
      default: baseTokens.color.grey['900'],
      onInverse: baseTokens.color.grey['0'],
    },
    static: {
      static: baseTokens.color.grey['900'],
      onInverse: baseTokens.color.grey['0'],
      onInverse2: baseTokens.color.grey['900'],
    },
    subtle: {
      default: baseTokens.color.grey['800'],
      onInverse: baseTokens.color.grey['400'],
    },
    muted: {
      default: baseTokens.color.grey['700'],
      onInverse: baseTokens.color.grey['200'],
    },
    placeholder: {
      default: baseTokens.color.grey['600'],
      onInverse: baseTokens.color.grey['300'],
    },
    disabled: {
      default: baseTokens.color.grey['500'],
      onInverse: baseTokens.color.grey['500'],
    },
    action: {
      base: baseTokens.color.green['700'],
      highlighted: baseTokens.color.green['900'],
      subtle: baseTokens.color.green['400'],
      muted: baseTokens.color.green['50'],
    },
    onBrand: {
      default: baseTokens.color.grey['0'],
      onInverse: baseTokens.color.grey['900'],
    },
  },
  feedback: {
    info: {
      default: {
        base: baseTokens.color.denim['600'],
        subtle: baseTokens.color.denim['50'],
      },
      static: {
        base: baseTokens.color.denim['600'],
        subtle: baseTokens.color.denim['50'],
      },
    },
    success: {
      default: {
        base: baseTokens.color.sage['600'],
        subtle: baseTokens.color.sage['50'],
      },
      static: {
        base: baseTokens.color.sage['600'],
        subtle: baseTokens.color.sage['50'],
      },
    },
    warning: {
      default: {
        base: baseTokens.color.orange['600'],
        subtle: baseTokens.color.orange['50'],
      },
      static: {
        base: baseTokens.color.orange['600'],
        subtle: baseTokens.color.orange['50'],
      },
    },
    error: {
      default: {
        base: baseTokens.color.cinnamon['600'],
        subtle: baseTokens.color.cinnamon['50'],
      },
      static: {
        base: baseTokens.color.cinnamon['600'],
        subtle: baseTokens.color.cinnamon['50'],
      },
    },
  },
  surface: {
    page: {
      base: baseTokens.color.grey['0'],
      subtle: baseTokens.color.grey['100'],
    },
    background: {
      neutral: {
        default: {
          base: baseTokens.color.grey['0'],
          raised: baseTokens.color.grey['100'],
          idle: baseTokens.color.grey['300'],
          subtle: baseTokens.color.sand['50'],
          strong: baseTokens.color.grey['600'],
          inverse: baseTokens.color.grey['900'],
          disabled: baseTokens.color.grey['300'],
        },
        static: {
          base: baseTokens.color.grey['0'],
          raised: baseTokens.color.grey['100'],
          idle: baseTokens.color.grey['300'],
          subtle: baseTokens.color.sand['50'],
          strong: baseTokens.color.grey['600'],
          inverse: baseTokens.color.grey['900'],
          disabled: baseTokens.color.grey['300'],
        },
      },
      brand: {
        default: {
          base: baseTokens.color.grey['900'],
          highlighted: baseTokens.color.grey['800'],
          subtle: baseTokens.color.grey['600'],
          muted: baseTokens.color.grey['100'],
          pale: baseTokens.color.grey['200'],
        },
      },
    },
    overlay: {
      backdrop: baseTokens.color.grey.alpha['900']['40'],
      scrim: {
        default: baseTokens.color.grey.alpha['0']['60'],
        subtle: baseTokens.color.grey.alpha['0']['40'],
      },
      disabled: {
        default: baseTokens.color.grey.alpha['900']['20'],
        onInverse: baseTokens.color.grey.alpha['900']['40'],
      },
    },
  },
  border: {
    neutral: {
      default: {
        base: baseTokens.color.grey['900'],
        idle: baseTokens.color.grey['500'],
        subtle: baseTokens.color.grey['300'],
        disabled: baseTokens.color.grey['400'],
      },
      static: {
        base: baseTokens.color.grey['900'],
        idle: baseTokens.color.grey['500'],
        subtle: baseTokens.color.grey['300'],
        disabled: baseTokens.color.grey['400'],
      },
    },
    focus: {
      default: baseTokens.color.grey['500'],
    },
    brand: {
      base: baseTokens.color.grey['900'],
      highlighted: baseTokens.color.grey['800'],
      subtle: baseTokens.color.grey['600'],
      muted: baseTokens.color.grey['0'],
    },
    onBrand: {
      default: baseTokens.color.grey['0'],
      onInverse: baseTokens.color.grey['900'],
      disabled: baseTokens.color.grey['500'],
    },
  },
  accent: {
    green: {
      default: {
        base: baseTokens.color.green['700'],
        subtle: baseTokens.color.green['400'],
        pale: baseTokens.color.green['100'],
        muted: baseTokens.color.green['50'],
      },
      static: {
        base: baseTokens.color.green['700'],
        subtle: baseTokens.color.green['400'],
        pale: baseTokens.color.green['100'],
        muted: baseTokens.color.green['50'],
      },
    },
    yellow: {
      default: {
        base: baseTokens.color.yellow['400'],
        subtle: baseTokens.color.yellow['100'],
        pale: baseTokens.color.yellow['100'],
        muted: baseTokens.color.yellow['50'],
      },
      static: {
        base: baseTokens.color.yellow['400'],
        subtle: baseTokens.color.yellow['200'],
        pale: baseTokens.color.yellow['100'],
        muted: baseTokens.color.yellow['50'],
      },
    },
    indaco: {
      default: {
        base: baseTokens.color.indaco['700'],
        subtle: baseTokens.color.indaco['400'],
        pale: baseTokens.color.indaco['100'],
        muted: baseTokens.color.indaco['50'],
      },
      static: {
        base: baseTokens.color.indaco['700'],
        subtle: baseTokens.color.indaco['400'],
        pale: baseTokens.color.indaco['100'],
        muted: baseTokens.color.indaco['50'],
      },
    },
    grey: {
      default: {
        base: baseTokens.color.grey['400'],
        subtle: baseTokens.color.grey['300'],
        pale: baseTokens.color.grey['200'],
        muted: baseTokens.color.grey['100'],
      },
      static: {
        base: baseTokens.color.grey['400'],
        subtle: baseTokens.color.grey['300'],
        pale: baseTokens.color.grey['200'],
        muted: baseTokens.color.grey['100'],
      },
    },
    sand: {
      default: {
        base: baseTokens.color.sand['400'],
        subtle: baseTokens.color.sand['200'],
        pale: baseTokens.color.sand['100'],
        muted: baseTokens.color.sand['50'],
      },
      static: {
        base: baseTokens.color.sand['400'],
        subtle: baseTokens.color.sand['200'],
        pale: baseTokens.color.sand['100'],
        muted: baseTokens.color.sand['50'],
      },
    },
    violet: {
      default: {
        base: baseTokens.color.violet['700'],
        subtle: baseTokens.color.violet['400'],
        pale: baseTokens.color.violet['100'],
        muted: baseTokens.color.violet['50'],
      },
      static: {
        base: baseTokens.color.violet['700'],
        subtle: baseTokens.color.violet['400'],
        pale: baseTokens.color.violet['100'],
        muted: baseTokens.color.violet['50'],
      },
    },
  },
  danger: {
    base: baseTokens.color.cinnamon['600'],
    subtle: baseTokens.color.cinnamon['500'],
    highlighted: baseTokens.color.cinnamon['800'],
    muted: baseTokens.color.cinnamon['50'],
    pale: baseTokens.color.cinnamon['100'],
  },
} as const satisfies SemanticTokens;
